import z from 'zod';
import { defineObject } from 'sanity-typed-queries';
var schema = defineObject('jobListingSection', {
    enableTaxonomyFilter: {
        title: 'Enable taxonomy filter',
        type: 'boolean'
    }
});
var validator = z.object({
    enableTaxonomyFilter: z.boolean()
}).partial();
schema.jobListingSection;
export default {
    schema: schema,
    validator: validator
};

//# sourceMappingURL=jobListingSection.js.map